module.exports = __webpack_public_path__ + "media/ring.e0c786cc.mp3";